let saveAs
if (import.meta.client) {
  saveAs = (await import('file-saver')).default
}

export function s2ab(s) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}

export function exportCsv(data: any[][], fileName: string) {
  if (import.meta.server) {
    return
  }
  if (!fileName) fileName = 'export'
  const csv = data
    .map(row =>
      row
        .map(col => (col == null ? '' : col.toString()))
        .map(col => {
          col = col.replace(/"/, '""')
          if (/[\r\n,"]/.test(col)) {
            return `"${col}"`
          } else {
            return col
          }
        })
        .join(','),
    )
    .join('\r\n')
  saveAs(
    new Blob([csv], {
      type: 'text/csv;charset=utf-8',
    }),
    fileName + '.csv',
  )
}

export function exportText(text: string, fileName: string) {
  if (import.meta.server) {
    return
  }
  saveAs(
    new Blob([text], {
      type: 'text/plain;charset=utf-8',
    }),
    fileName,
  )
}

export function exportJSON(data: any, fileName: string) {
  if (import.meta.server) {
    return
  }
  saveAs(
    new Blob([JSON.stringify(data)], {
      type: 'application/json;charset=utf-8',
    }),
    fileName,
  )
}
